import React from "react";

import { CONSTANT } from "../../../constant/Constant";
import { ParagraphRenderer } from "./ParagraphRenderer";

export default function About({service}) {

  return (
    <>
      {service !== null && service !== undefined && (
        <div className="py-10 h-auto w-full grid grid-cols-1 justify-center items-center">
          <div className="h-full w-screen flex justify-center items-center py-10 ">
            <div className="h-auto w-5/6 max-w-screen-2xl ">
              <p className="text-left font-extrabold text-4xl font-mono">
                SERVICES
              </p>
            </div>
          </div>
          <div className="flex justify-center items-center pb-10">
            <div className=" h-auto w-[80%]  max-w-screen-2xl">
              <div className=" w-full grid gap-10 grid-cols-3 h-auto min-w-fit">
                <p className="block lg:hidden text-end font-semibold text-2xl border-b-2 w-full col-span-3">
                  STYLED TO PERFECTION
                </p>
                <div className="text-end col-span-3 lg:col-span-2 gap-5 flex flex-col justify-center items-end overflow-scroll no-scrollbar">
                  <p className="hidden lg:block text-left font-semibold text-2xl border-b-2">
                    STYLED TO PERFECTION
                  </p>
                  <ParagraphRenderer text={service.desp1} />
                </div>
                <div className="col-span-3 lg:col-span-1 w-full flex justify-center items-center">
                  <img
                    className="object-cover h-[300px] w-[100%] rounded-xl"
                    src={`${CONSTANT.UI_URL}service/${service.svcImg1}`}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center pb-10 mt-20">
            <div className="max-w-screen-2xl h-auto w-[80%]">
              <div className=" w-full grid gap-10 grid-cols-3 h-auto min-w-fit ">
                <p className="block lg:hidden text-start font-semibold text-2xl border-b-2 w-full col-span-3">
                  CLICK. CAPTURE. CHERISH
                </p>
                <div className="col-span-3 lg:col-span-1 w-full flex justify-center items-center ">
                  <img
                    className="object-cover h-[300px] w-[100%] rounded-xl"
                    src={`${CONSTANT.UI_URL}service/${service.svcImg2}`}
                    alt=""
                  />
                </div>
                <div className="text-start col-span-3 justify-center lg:col-span-2 gap-5 flex flex-col items-start overflow-scroll no-scrollbar">
                  <p className="hidden lg:block text-start font-semibold text-2xl border-b-2 ">
                    CLICK. CAPTURE. CHERISH
                  </p>
                  <ParagraphRenderer text={service.desp2} />
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center items-center mt-20">
            <div className="max-w-screen-2xl w-[80%]">
              <div className=" w-full grid gap-10 grid-cols-3 min-w-fit  ">
                <p className="block lg:hidden text-end font-semibold text-2xl border-b-2 w-full col-span-3">
                  FLAVORS & BEATS
                </p>
                <div className=" text-end col-span-3 justify-center lg:col-span-2 gap-5 flex flex-col items-end overflow-scroll no-scrollbar">
                  <p className="hidden lg:block text-start font-semibold text-2xl border-b-2">
                    FLAVORS & BEATS
                  </p>
                  <ParagraphRenderer text={service.desp3} />
                </div>
                <div className="col-span-3 lg:col-span-1 w-full flex justify-center items-center">
                  <img
                    className="object-cover h-[300px] w-[100%] rounded-xl"
                    src={`${CONSTANT.UI_URL}service/${service.svcImg3}`}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
